<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="5">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <Form v-slot="{ meta }">
                <form id="resetPassword">
                  <h3>Greetings, {{ displayName }}</h3>
                  <p class="text-muted">For security purpose, please change your password before proceed.</p>
                  <div class="text-muted">
                    <p>
                      Your new password must be 8 to 32 characters with combination of:
                    </p>
                    <ul>
                      <li>At least 1 uppercase alphabet</li>
                      <li>At least 1 lowercase alphabet</li>
                      <li>At least 1 number</li>
                      <li>At least 1 of these special characters .!#$%&@</li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <label for="password" class="required-field">Your New Password</label>
                    <Field v-model="new_password" rules="required|password" v-slot="{ field, errorMessage }" name="Password">
                      <input type="password" class="form-control" v-bind="field" maxlength="32">
                      <span class="text-error">{{ errorMessage }}</span>
                    </Field>
                  </div>

                  <div class="form-group">
                    <label for="confirmedPassword" class="required-field">Re-type Password to confirm</label>
                    <Field rules="required|password_confirm:@Password" v-slot="{ field, errorMessage }"
                      name="Password Confirmation">
                      <input type="password" class="form-control" v-bind="field" v-model="confirmed_password" maxlength="32">
                      <span class="text-error">{{ errorMessage }}</span>
                    </Field>
                  </div>

                  <div class="row">
                    <div class="form-group col-12">
                      <button type="button" class="btn btn-success text-white w-100" @click="resetBtn"
                        :disabled="!meta.valid">Change Now</button>
                    </div>
                  </div>
                </form>
              </Form>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
    <CNotification />
  </CContainer>
</template>


<style>
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
}
</style>

<script>
import service from '@/services/userService'
import { CNotification } from '@/views/components/index.js'
import { Form, Field } from 'vee-validate'

export default {
  data() {
    return {
      email: '',
      token: '',
      new_password: '',
      confirmed_password: '',
    }
  },
  components: { CNotification, Form, Field },
  computed: {
    alert() {
      return this.$store.state.alert
    },
    displayName() {
      return localStorage.name
    }
  },
  methods: {
    resetBtn() {
      service.firstLogin(this.new_password, this.confirmed_password)
        .then(() => {
          service.logout()
        })
    }
  }
};
</script>